"use strict";

define('app/document/edit/document.edit.controller',['require','exports','module','rs/abstract.content.controller','app/document/edit/document.edit.view','rs/form/factory','rs/models/pdf','rs/helper','rs/checklist/checklist.controller','e3-modal','moment'],function (require, exports, module) {
  var AbstractContentController = require('rs/abstract.content.controller');
  var SubmissionEditView = require('app/document/edit/document.edit.view');
  var FormFactory = require('rs/form/factory');
  var PDFGenerator = require('rs/models/pdf');
  var helper = require('rs/helper');
  var ChecklistController = require('rs/checklist/checklist.controller');
  var E3Modal = require('e3-modal');
  var moment = require('moment');
  var SubmissionEditController = AbstractContentController.extend({
    contentName: 'document-edit-content abstract-content off-white',
    properties: ['initialSectionIndex', 'formController', 'checklists', 'checklistController'],
    events: {
      'view:ready': 'render'
    },
    footer: false,
    setupView: function setupView() {
      this.setView(new SubmissionEditView());
    },
    getUserId: function getUserId() {
      return this.getAppController().getUser().getId();
    },
    start: function start(id, section) {
      this.setInitialSectionIndex(section);
      return FormFactory.createFormViewer(id, this.getUserId(), this.getAppController()).bind(this).tap(this.formDidLoad);
    },
    generatePDFDocument: function generatePDFDocument() {
      var doc = this.getFormController().getDocumentModel(),
        container = null,
        data = null,
        that = this;
      var popup = PDFGenerator.generatePopup();
      FormFactory.createFormPDFViewer(doc.getId(), this.getUserId(), this.getAppController()).then(function (formController) {
        data = that.getPDFProperties(formController);
        container = that.getView().getDocumentPDFElement(data);
        formController.setAppController(that.getAppController());
        formController.setup(container.find('.pdf-form-container'));
        return formController.getView().setupPDFElement();
      }).then(function () {
        PDFGenerator.requestCreatePDF(container.get(0), popup);
      }).lastly(this.showLoading());
    },
    requestPageSave: function requestPageSave() {
      return this.getFormController().requestSaveAction();
    },
    getPDFProperties: function getPDFProperties(formController) {
      var documentModel = formController.getDocumentModel(),
        assignmentsMap = formController.getAssignments().getMap();
      return {
        createDate: documentModel.createDate ? moment(documentModel.createDate).format('l') : null,
        date: moment().format('l'),
        doc: documentModel,
        status: helper.toProperCase(documentModel.status),
        assignments: assignmentsMap
      };
    },
    getVolatileDataSource: function getVolatileDataSource() {
      var fc = this.getFormController(),
        cc = this.getChecklistController(),
        fcState = fc ? fc.getUnsavedAttachments() || fc.hasUnsavedSections() : false,
        ccState = cc ? cc._userAnswerChange : false;
      return fcState && 'Submission' || ccState && 'Checklist';
    },
    hasVolatileData: function hasVolatileData() {
      return !!this.getVolatileDataSource();
    },
    formDidLoad: function formDidLoad(formController) {
      var view = this.getView(),
        doc = formController.getDocumentModel();
      this.setFormController(formController);
      formController.setAppController(this.getAppController());
      formController.setInitialSectionIndex(this.getInitialSectionIndex() || 0);
      formController.setup(view.getFormContainerElement());
      formController.setDelegate(this);
      this.formController = formController;
      this.updateDocumentTitle();
      return Promise.resolve().then(function () {
        if (doc.finalized) {
          return doc.requestHistoricalChecklistDocuments();
        } else {
          return doc.requestOpenChecklistDocuments();
        }
      }).bind(this).tap(function (checklists) {
        this.setupChecklists(checklists);
        this.formController.refreshToolbarActions();
      });
    },
    getDocumentTitle: function getDocumentTitle() {
      var formController = this.getFormController();
      if (formController) {
        return 'Submission - ' + formController.getDocumentModel().studyTitle + ' - ' + formController.getDocumentModel().templateType;
      }
    },
    getDocumentComments: function getDocumentComments() {
      var formController = this.getFormController();
      return formController.getComments();
    },
    hasChecklists: function hasChecklists() {
      return !_.isEmpty(this.getChecklists());
    },
    setupChecklists: function setupChecklists(checklists) {
      this.setChecklists(checklists);
      if (this.hasChecklists()) {
        var doc = this.formController.getDocumentModel();
        var cc = new ChecklistController(doc, this.getChecklists(), this.getAppController());
        cc.setup(document.createElement('div'));
        this.getView().getFormWrapperElement().append(cc.view.$el);
        this.setChecklistController(cc);
      }
    },
    unload: function unload() {
      this._super();
      if (this.formController) {
        return this.formController.unload();
      }
    },
    destroy: function destroy() {
      if (this.formController) {
        this.formController.destroy();
      }
      this._super();
    },
    canLeaveContentController: function canLeaveContentController() {
      return Promise.resolve(this._super.apply(this, arguments)).bind(this).tap(function () {
        if (this.formController) {
          return this.getFormController().releaseActiveLock();
        }
      });
    }
  });
  module.exports = SubmissionEditController;
});

